var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var RecipeRepository = /** @class */ (function () {
    function RecipeRepository(httpClient) {
        var _this = this;
        this.httpClient = httpClient;
        this.getFeaturedContents = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.get('/recipe/featured', {
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.getSeasonalRecipes = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.get('/recipe/seasonal', {
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.getWeeklyRecipe = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.get('/recipe/week', {
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.getRecipe = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var recipeId = _b.recipeId, recipeDetailsType = _b.recipeDetailsType, date = _b.date, mealType = _b.mealType;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.httpClient.get("/recipe/".concat(recipeId, "/").concat(recipeDetailsType), {
                            params: {
                                date: date,
                                type: mealType,
                            },
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        }); };
        this.getRecipePreferences = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var recipeId = _b.recipeId;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.httpClient.get("/family/recipe/".concat(recipeId, "/preferences"), {
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        }); };
        this.getRecipePreview = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var recipeId = _b.recipeId;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.httpClient.get("/recipe/preview/".concat(recipeId))];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        }); };
        this.getRecipes = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var search = _b.search, skip = _b.skip, take = _b.take, categoriesId = _b.categoriesId, cuisineTypeId = _b.cuisineTypeId, ingredientsId = _b.ingredientsId, preparationTime = _b.preparationTime, seasonal = _b.seasonal, fodmaps = _b.fodmaps, budgetFriendly = _b.budgetFriendly, lunchbox = _b.lunchbox, noCook = _b.noCook, macroNutrients = _b.macroNutrients, favourites = _b.favourites;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.httpClient.post("/recipe", {
                            isAuthorized: true,
                            body: {
                                search: search,
                                skip: skip,
                                take: take,
                                categoriesId: categoriesId,
                                cuisineTypeId: cuisineTypeId,
                                ingredientsId: ingredientsId,
                                seasonal: seasonal,
                                fodmaps: fodmaps,
                                budgetFriendly: budgetFriendly,
                                lunchbox: lunchbox,
                                noCook: noCook,
                                preparationTime: preparationTime,
                                macroNutrients: macroNutrients,
                                favourites: favourites,
                            },
                        })];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        }); };
        this.getSundayRecipes = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.get("/recipe/tag/sunday-recipes", {
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.addRecipeToPlan = function (req) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.post("/plan/addRecipe", {
                            body: req,
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
    }
    return RecipeRepository;
}());
export { RecipeRepository };
